import React,{useState} from "react"
import  {useLocation as location2} from "wouter";
import Loading from "../components/Loading";
import Alert from "../components/Alert";
import post from "../post";
import * as Constants from '../constants';

const Login = (props) => {
    const [location, navigate] = location2();
    const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });  
    const [loading, setLoading] = useState(false);
    const user_id = localStorage.getItem('token');
    if (user_id) {
        navigate('/');
    }
    const attemptLogin = async () => {
        setLoading(true);
        const email = document.getElementById('email').value.trim();
        const password = document.getElementById('password').value.trim();
        if (!email || !password) {
            setAlert({ isOpen: true, title: 'Error', message: 'Por favor, completa todos los campos.' });
            setLoading(false);
            return;
        }
        const token=btoa(Array(30).fill(null).map(() => Math.random().toString(36).charAt(2)).join(''));
        
        const response = await post('login', { email:email, pass:password,token:token });
        setLoading(false);
        if(!response.result){
            setAlert({ isOpen: true, title: 'Error', message: response.motive || 'Error al iniciar sesión. Por favor, intenta de nuevo.' });
            return;
        }
        localStorage.setItem('token', token);
        navigate('/');
        
    }
    return (
        <div id="webcrumbs">
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
                <Loading isOpen={loading} />
                <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => setAlert({ isOpen: false, title: '', message: '' })} />
                <div className="w-full max-w-md px-6 py-10">
                    <div className="flex flex-col items-center mb-10">
                        <div className="w-40 h-40 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg">
                            <img src={Constants.LOGO_URL} alt="Logo"  className="" />
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">{Constants.BUSINESS_NAME}</h1>
                        <p className="text-neutral-600 text-center">
                            Bienvenido de nuevo. Por favor, inicia sesión para continuar.
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        <form className="space-y-5">
                            <div className="space-y-2">
                                <label htmlFor="email" className="block text-sm font-medium text-neutral-700">
                                    Correo electrónico
                                </label>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">mail</span>
                                    </span>
                                    <input
                                        type="email"
                                        id="email"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="usuario@ejemplo.com"
                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <div className="flex justify-between">
                                    <label htmlFor="password" className="block text-sm font-medium text-neutral-700">
                                        Contraseña
                                    </label>
                                    <a
                                        href="#"
                                        className="text-sm text-primary-600 hover:text-primary-700 transition-colors tex"
                                    >
                                        ¿Olvidaste la contraseña?
                                    </a>
                                </div>
                                <div className="relative">
                                    <span className="absolute inset-y-0 left-3 flex items-center text-neutral-400">
                                        <span className="material-symbols-outlined text-xl">lock</span>
                                    </span>
                                    <input
                                        type="password"
                                        id="password"
                                        className="w-full pl-10 pr-4 py-3 border border-neutral-200 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all bg-neutral-50 placeholder-neutral-400 text-neutral-700"
                                        placeholder="********"
                                    />
                                </div>
                            </div>

                            <button
                                type="button"
                                className="w-full bg-primary-600 text-white py-3.5 rounded-xl font-medium shadow-sm hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                onClick={attemptLogin}
                            >
                                Iniciar sesión
                            </button>
                        </form>

                        {/*<div className="relative flex items-center my-6">
                            <div className="flex-grow border-t border-neutral-200"></div>
                            <span className="flex-shrink mx-4 text-neutral-400 text-sm">o continúa con</span>
                            <div className="flex-grow border-t border-neutral-200"></div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <button className="flex items-center justify-center gap-2 py-3 border border-neutral-200 rounded-xl font-medium hover:bg-neutral-50 transition-colors">
                                <img
                                    src="https://img.icons8.com/color/24/null/google-logo.png"
                                    alt="Google logo"
                                    className="w-5 h-5"
                                />
                                <span className="text-neutral-700">Google</span>
                            </button>
                            <button className="flex items-center justify-center gap-2 py-3 border border-neutral-200 rounded-xl font-medium hover:bg-neutral-50 transition-colors">
                                <img
                                    src="https://img.icons8.com/?size=100&id=95294&format=png&color=000000"
                                    alt="Apple logo"
                                    className="w-5 h-5"
                                />
                                <span className="text-neutral-700">Apple</span>
                            </button>
                        </div>*/}
                    </div>

                    <div className="text-center">
                        <p className="text-neutral-600">
                            ¿No tienes una cuenta?{" "}
                            <a
                                href="/register"
                                className="text-primary-600 font-medium hover:text-primary-700 transition-colors"
                            >
                                Regístrate ahora
                            </a>
                        </p>
                    </div>

                    <div className="mt-10 text-center text-xs text-neutral-500">
                        <p>
                            Al continuar, aceptas nuestros{" "}
                            <a href="#" className="text-primary-600 hover:underline">
                                Términos de servicio
                            </a>{" "}
                            y{" "}
                            <a href="#" className="text-primary-600 hover:underline">
                                Política de privacidad
                            </a>
                            .
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;